export var api ={
    baseUrl: process.env.REACT_APP_API_URL as string,
}